import { render, staticRenderFns } from "./salesDispatchManagement.vue?vue&type=template&id=aa1a1036&scoped=true&"
import script from "./salesDispatchManagement.vue?vue&type=script&lang=js&"
export * from "./salesDispatchManagement.vue?vue&type=script&lang=js&"
import style0 from "./salesDispatchManagement.vue?vue&type=style&index=0&id=aa1a1036&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa1a1036",
  null
  
)

export default component.exports